The three-letter ISO 4217 currency code, in uppercase.

For the `seekAnz` scheme, the following currencies are accepted:

- `AUD`
- `BDT`
- `CNY`
- `EUR`
- `GBP`
- `HKD`
- `IDR`
- `INR`
- `JPY`
- `MYR`
- `NZD`
- `PHP`
- `SGD`
- `THB`
- `USD`
- `VND`
